<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"checkpoints",

        data(){
            return {
                // icons:{pis:"/images/pis.svg", 
                //     largada:"/images/largada.svg",
                // },
                loadDelay:4,
            }
        },

        computed:{
            geoJSON:function(){
                return this.$store.getters.checkpointsGeoJson;
            },
        },

        watch:{
            geoJSON:function(){
                    setTimeout( ()=>this.animateFeatures(4, false),0);            }
        },

        methods:{

        },

        style: function () {
            return {
                "type": "symbol",
                "layout": {
                    "text-field": "{index}",
                    "text-anchor": "bottom",
                    "text-line-height": 1,
                    "text-optional": true,
                    'text-size':12,
                    "text-offset": {
                        "base": 1,
                        "stops": [
                            [11, [0.5, -1.5]],
                            [14, [1.5, -3.4]]
                        ],
                    },
                    "icon-image": ['case', ['==',['get','index'],0], 'largada','pis'],  //"pis",
                    "icon-anchor": "bottom-left",
                    "icon-allow-overlap": true,
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [8.9, 0.1],
                            [11, 0.5],
                            [14, 1.3]
                        ]
                    },
                },
                "paint": {
                    "text-color": "white",
                    "text-halo-color": "white",
                    "text-halo-width": 0.4,
                    "text-halo-blur": 0.4,
                    "text-opacity": {
                        "base": 1,
                        "stops": [
                            [10, 0],
                            [13, 1]
                        ],
                    },

                }
            }
        }

    }


</script>